import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import CategoryIndex from "../../../components/SidetabPages/TemplateCategory/CategoryIndex";

const Category = () => {
  return (
    <>
      <AnnouncementBar />
      <CategoryIndex />
    </>
  );
};
export default Category;
